module.exports = __webpack_public_path__ + "img/block_bg_5.3eabc104.webp";